function isFunction(object) {
  return typeof object === 'function';
}

function isNotFunction(object) {
  return !isFunction(object);
}

function createBulkThunkMiddleware() {
  return ({ dispatch, getState }) =>
    (next) =>
    (action) => {
      if (action.type === 'BATCH_ACTIONS') {
        action.actions.filter(isFunction).map((actionFn) => actionFn(dispatch, getState));
      }

      return next(action);
    };
}

function enableBatching(reducer) {
  return function batchingReducer(state, action) {
    switch (action.type) {
      case 'BATCH_ACTIONS':
        return action.actions.filter(isNotFunction).reduce(batchingReducer, state);

      default:
        return reducer(state, action);
    }
  };
}

export { createBulkThunkMiddleware, enableBatching };
